import React, { FC, useState } from 'react';
import { Button } from '../../../modules/ui-kit-react/lib';
import { ButtonProps } from '../../../modules/ui-kit-react/lib/components/Button';
import { ProjectGroup } from "types/api";
import Modal from '../AddProjectGroupToGroup';

interface ComponentProps {
  projectGroup: ProjectGroup;
}

const Component: FC<ComponentProps & Partial<ButtonProps>> = ({
  projectGroup,
  ...buttonProps
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        flat
        appearance="primary"
        icon="add"
        onClick={() => setShowModal(true)}
        {...buttonProps}
      >
        Add Project Group
      </Button>

      <Modal
        active={showModal}
        projectGroup={projectGroup}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default Component;
